import { render, staticRenderFns } from "./SalesLeaveRequestsTable.vue?vue&type=template&id=8f7ff86e&scoped=true&"
import script from "./SalesLeaveRequestsTable.vue?vue&type=script&lang=js&"
export * from "./SalesLeaveRequestsTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeaveRequestsTable.vue?vue&type=style&index=0&id=8f7ff86e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7ff86e",
  null
  
)

export default component.exports